import {
  CognitoUserPool,
  CognitoUser
} from "amazon-cognito-identity-js";
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useInputChange } from '../../helpers/useInputChange'

const ForgottenPasswordPage = (props) => {

  const [email, setEmail] = useInputChange(props.email)
  const [code, setCode] = useInputChange(props.code)
  const [newPassword, setNewPassword] = useInputChange()
  const [error, setError] = useState()

  const [codeSent, setCodeSent] = React.useState()

  const history = useHistory();
  const {t} = useTranslation()

  const userPool = new CognitoUserPool({
    UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENTID,
  });

  const onSubmit = (e) => {
    e.preventDefault()
    
    setError(false)

    let button = e.currentTarget
    if (button.clicked) {
      return
    }
    button.clicked = true

    var userData = {
      Username: email,
      Pool: userPool,
    };

    var cognitoUser = new CognitoUser(userData);

    if (codeSent) {
      cognitoUser.confirmPassword(code, newPassword, {
        onSuccess() {
          history.push("/workflows")
        },
        onFailure(err) {
          button.clicked = false
          setError(err.message)        
        },
      });
    } else {
      cognitoUser.forgotPassword({
        onSuccess: function (data) {
          button.clicked = false
          // successfully initiated reset password request
          setCodeSent(true)
        },
        onFailure: function (err) {
          button.clicked = false
          if (err.code === "UserNotFoundException") {
            setError(t("UserNotFoundException"))
          }
          else {
            setError(err.message)
          }
        }
      });
    }
  }

  document.title = t("titleappname") + t("title_forgotten_password")
  
  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_forgotten_password")}</h3>
      {codeSent == true ? <>
          <small className="text-success">{t("forgotten_password_email_sent")}</small><br/><br/></>
      : ""}
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          onChange={setEmail}
          required={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>
      {codeSent == true ? <>
          <div className="wrap-input100 validate-input">
            <span className="label-input100">{t("lbl_code")}</span>
            <input className="form-control"
              type="text"
              name="code"
              autoComplete="off"
              id="code"
              placeholder={t("tip_code")}
              onChange={setCode}               
              required={true}
              pattern="^\d{6}$" title={t("val_code")}/>
            <span className="focus-input100" data-symbol="&#xf292;"></span>
          </div>
          <div className="wrap-input100 validate-input">
            <span className="label-input100">{t("lbl_new_password")}</span>
            <input className="form-control"
              type="password"
              name="new-password"
              autoComplete="new-password"
              id="new-password"
              placeholder={t("tip_password")}
              onChange={setNewPassword}
              required={true} pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}" title={t("val_password")} />
            <span className="focus-input100" data-symbol="&#xf023;"></span>
          </div>
        </>
      : ""}
      <br />
      {error ? <small id="errorMessage" className="text-danger">{error}<br/></small> : ""}
      <div>
        <input type="submit" className="submit-btn" value={t("btn_confirmation_submit")}/>
      </div>
    </form>
  </div>
}

export default ForgottenPasswordPage